import { FormControl, Grid, IconButton, TextField, Typography, Autocomplete
    , FormControlLabel, Checkbox, Box, InputLabel, Select, MenuItem, ListItemText, InputAdornment } from '@mui/material';
import { Add as IconAdd, Search as IconSearch, AddCircle as IconAddCircle, Edit as IconEdit } from "@mui/icons-material";
import api from "../services/api";
import * as filialService from "../services/filialService";
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListParticipantes, setListNivelLenguaje, setListColegio, setListGradoColegio, setListTipoSeguro, setListTipoTerapia, defaultParticipante } from "../redux/memberSlice";
import { FormHelperText as HelperText } from '@mui/material';
import DirectionSearch from './DirectionSearch';
import AutocompleteLista from './common/AutocompleteLista';
import MemberSearch from './PersonSearch';
import MemberRegister from './PersonRegister';
import FatherSearch from './PersonSearch';
import FatherRegister from './PersonRegister';
import MotherSearch from './PersonSearch';
import MotherRegister from './PersonRegister';

const Member = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const participante = useSelector((state) => state.member.participante);
    const [listFiliales, setListFiliales] = useState([]);
    
    const listParticipantes = useSelector((state) => state.member.listParticipantes);
    //listTerapeutas
    const listNivelLenguaje = useSelector((state) => state.member.listNivelLenguaje);
    const listColegio = useSelector((state) => state.member.listColegio);
    const listGradoColegio = useSelector((state) => state.member.listGradoColegio);
    const listTipoSeguro = useSelector((state) => state.member.listTipoSeguro);
    const listTipoTerapia = useSelector((state) => state.member.listTipoTerapia);

    // const defaultParticipante = useSelector((state) => state.member.defaultParticipante);
    const validate = useSelector((state) => state.member.validationActive);

    const [openDirectionSearch, setOpenDirectionSearch] = useState(false)
    const openCloseDirectionSearch = () => { setOpenDirectionSearch(!openDirectionSearch); }

    const [openSearchMember, setOpenSearchMember] = useState(false)
    const openCloseSearchMember = () => { setOpenSearchMember(!openSearchMember); }
    const [openMemberRegister, setOpenMemberRegister] = useState(false)
    const openCloseMemberRegister = () => { setOpenMemberRegister(!openMemberRegister); }

    const [openSearchFather, setOpenSearchFather] = useState(false)
    const openCloseSearchFather = () => { setOpenSearchFather(!openSearchFather); }
    const [openFatherRegister, setOpenFatherRegister] = useState(false)
    const openCloseFatherRegister = () => { setOpenFatherRegister(!openFatherRegister); }

    const [openSearchMother, setOpenSearchMother] = useState(false)
    const openCloseSearchMother = () => { setOpenSearchMother(!openSearchMother); }
    const [openMotherRegister, setOpenMotherRegister] = useState(false)
    const openCloseMotherRegister = () => { setOpenMotherRegister(!openMotherRegister); }

    const dispatch = useDispatch();
    const fechaIngresoMinimo = new Date(2010, 1, 1);

    const filialEfectiva = participante.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0);

    var validation = {
        participante: {
            error: participante.participante != null && participante.participante.length < 3,
            message: "Falta ingresar el participante",
        },
        idFilial: {
            error: !filialEfectiva || filialEfectiva === 0,
            message: "Seleccione la filial",
        },
        fechaIngreso: {
            error: Date.parse(participante.fechaIngreso) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
    }

    useEffect(() => {
        if (participante?.idPersona > 0) {
            props.onPersonaChange(participante.idPersona);
        }
    }, [participante?.idPersona]);

    const fetchParticipante = useCallback(async () => {
        if (!params.id || params.id == "0" || params.id == 0) {
            dispatch(setEntity({
                ...defaultParticipante,
                idFilial: idFilialUsuario > 0 ? idFilialUsuario : 0
            }));
            return;
        }

        const response = await api.get("/Participante/GetParticipanteViewById?idParticipante=" + params.id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        // Si el participante no existe se cargan los valores por defecto: dejar el
        // entidad en null hacia fallar la pantalla.
        if (!response?.data?.data) {
            dispatch(setEntity({
                ...defaultParticipante,
                idFilial: idFilialUsuario > 0 ? idFilialUsuario : 0
            }));
        } else {
            const data = response.data.data;
            dispatch(setEntity({
                ...data,
                idFilial: data.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0)
            }));
        }
    }, [params.id, idFilialUsuario, dispatch])
    const fetchListParticipantes = useCallback(async () => {
        const response = await api.get("/Persona/GetsListNaturalPersonByTypeAndName?idType=24&name=")
            .catch((err) => {
                console.log("Err: ", err);
            });
        
        dispatch(setListParticipantes(response.data.data));
    }, [])
    const fetchListNivelLenguaje = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=111")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListNivelLenguaje(response.data.data));
    }, [])
    const fetchListColegio = useCallback(async () => {
        // Los colegios son las personas juridicas cuyo tipo es Colegio: el 229,
        // del catalogo "Tipos de Persona Entidad" (228), que es el mismo del
        // desplegable de tipo de la persona juridica.
        const response = await api.get("/Persona/GetsListLegalPersonByTypeAndName?idType=229&name=")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setListColegio(response.data.data));
    }, [])

    // La carga del autocomplete de colegios: con texto busca en el servidor.
    const cargarColegios = useCallback(async (texto) => {
        const response = await api.get(
            `/Persona/GetsListLegalPersonByTypeAndName?idType=229&name=${encodeURIComponent(texto || "")}`)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: { data: [] } };
            });

        return (response?.data?.data || []).map((row) => ({ id: row.id, descripcion: row.descripcion }));
    }, [])
    const fetchListGradoColegio = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=118")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListGradoColegio(response.data.data));
    }, [])
    const fetchListTipoSeguro = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=130")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListTipoSeguro(response.data.data));
    }, [])
    const fetchListTipoTerapia = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=133")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setListTipoTerapia(response.data.data));
    }, [])

    const fetchListFiliales = useCallback(async () => {
        const data = await filialService.getFilialesList().catch(() => []);
        const lista = filialService.soloFilialDelUsuario(data, idFilialUsuario);
        setListFiliales(lista);
        if (idFilialUsuario > 0 && (!params.id || params.id == "0")) {
            dispatch(setData({ name: "idFilial", value: idFilialUsuario }));
        }
    }, [idFilialUsuario, params.id, dispatch]);

    useEffect(() => {
        fetchListFiliales();
    }, [fetchListFiliales]);

    useEffect(() => {
        fetchParticipante();
    }, [fetchParticipante]);

    useEffect(() => {
        fetchListParticipantes();
        fetchListNivelLenguaje();
        fetchListColegio();
        fetchListGradoColegio();
        fetchListTipoSeguro();
        fetchListTipoTerapia();
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [participante, idFilialUsuario]);

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    const setSelectDirectionSearch = (select) => {
        dispatch(setData({name: "idDireccionCasoAccidente", value: select.id}));
        dispatch(setData({name: "ubigeoCasoAccidente", value: select.ubigeo}));
        dispatch(setData({name: "direccionCasoAccidente", value: select.detalle}));
    }
    const setMemberNew = (id, name) => {
        dispatch(setData({name: "idPersona", value: id}));
        dispatch(setData({name: "participante", value: name}));

        props.onPersonaChange(id);
    }
    const setMemberFound = (select) => {
        dispatch(setData({name: "idPersona", value: select.idPersona}));
        dispatch(setData({name: "participante", value: select.nombres}));

        props.onPersonaChange(select.idPersona);
    }
    const setFatherNew = (id, name) => {
        dispatch(setData({name: "idPadre", value: id}));
        dispatch(setData({name: "padre", value: name}));
    }
    const setFatherFound = (select) => {
        dispatch(setData({name: "idPadre", value: select.idPersona}));
        dispatch(setData({name: "padre", value: select.nombres}));
    }
    const setMotherNew = (id, name) => {
        dispatch(setData({name: "idMadre", value: id}));
        dispatch(setData({name: "madre", value: name}));
    }
    const setMotherFound = (select) => {
        dispatch(setData({name: "idMadre", value: select.idPersona}));
        dispatch(setData({name: "madre", value: select.nombres}));
    }

    // La misma plantilla en cada fila: la primera columna cabe el check
    // con aire, y Colegio / Grado / Fecha / Direccion comparten bordes.
    const fila = {
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "220px minmax(0, 1fr) minmax(0, 1fr)" },
        columnGap: 2,
        rowGap: 1,
        alignItems: "center",
        width: "100%",
        "& .MuiFormControlLabel-root": { mr: 0, ml: 0 },
        "& .MuiFormControlLabel-label": { whiteSpace: "nowrap" },
    };

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(participante)} */}
            <Grid item xs={12}>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"} sx={{ justifyContent: "flex-start", alignItems: "flex-start" }}>
                <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={5}>
                        <FormControl required fullWidth error={validate.participante && validation.participante.error}>
                            <TextField
                                name="participante"
                                label="Participante"
                                value={participante.participante}
                                fullWidth
                                size="small"
                                disabled={isReadOnly}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="Buscar Participante" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                openCloseSearchMember()
                                            }}>
                                                <IconSearch fontSize="small" />
                                            </IconButton>
                                            <IconButton aria-label="Registrar Participante" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                openCloseMemberRegister()
                                            }}>
                                                {participante.idPersona > 0 ? <IconEdit fontSize="small" /> : <IconAddCircle fontSize="small" />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <HelperText>{validate.participante && validation.participante.error ? validation.participante.message : ""}</HelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                        <FormControl required fullWidth error={validate.idFilial && validation.idFilial?.error}>
                            <InputLabel htmlFor="input-filial">Filial</InputLabel>
                            <Select
                                native
                                label="Filial"
                                value={participante.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0)}
                                onChange={(e) => dispatch(setData({ name: "idFilial", value: parseInt(e.target.value, 10) || 0 }))}
                                inputProps={{ name: 'idFilial', id: 'input-filial' }}
                                disabled={isReadOnly || idFilialUsuario > 0}
                                size="small"
                            >
                                {idFilialUsuario <= 0 && <option key={0} value={0}>{"(Seleccione)"}</option>}
                                {listFiliales.map((row) => (
                                    <option key={row.id} value={row.id}>{row.descripcion || row.nombre}</option>
                                ))}
                            </Select>
                            <HelperText>{validate.idFilial && validation.idFilial?.error ? validation.idFilial.message : ""}</HelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3.5}>
                        <TextField
                            required
                            name="fechaIngreso"
                            label="Fecha Ingreso"
                            fullWidth
                            type="date"
                            value={participante.fechaIngreso ? moment(participante.fechaIngreso).format('yyyy-MM-DD') : ''}
                            onChange={setDataEntity}
                            error={validate.fechaIngreso && validation.fechaIngreso.error}
                            helperText={validate.fechaIngreso && validation.fechaIngreso.error ? validation.fechaIngreso.message : ""}
                            disabled={isReadOnly}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
                </Grid>
                {/* <Grid item xs={6} sm={4}>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-nivellenguaje">Nivel Lenguaje</InputLabel>
                        <Select
                            // native
                            label="nivelLenguaje"
                            multiple
                            value={[participante?.idNivelLenguaje] || [0]}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idNivelLenguaje',
                                id: 'input-nivellenguaje',
                            }}
                            size="small"
                        >
                            {listNivelLenguaje.map((op) => (
                            <MenuItem key={op.id} value={op.id}>
                                <Checkbox checked={seleccionados.includes(op.id)} />
                                <ListItemText primary={op.descripcion} />
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid> */}
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneEscolaridad"
                            checked={participante.tieneEscolaridad}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneEscolaridad", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Escolaridad" />    
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    {/* <FormControl required fullWidth error={validate.terapeuta && validation.terapeuta.error}>*/}
                    <FormControl required fullWidth>
                        {/* Los colegios son las personas juridicas cuyo tipo es Colegio.
                            La lista crece con cada colegio que se registra, asi que el
                            desplegable es un autocomplete: al abrirlo estan los
                            primeros 50 (en orden alfabetico) y al escribir se busca en
                            el servidor. */}
                        <AutocompleteLista
                            label="Colegio"
                            name="idColegio"
                            size="small"
                            disabled={isReadOnly}
                            value={participante.idColegio || 0}
                            texto={participante.colegio || ""}
                            cargar={cargarColegios}
                            onChange={(id, texto) => {
                                dispatch(setData({ name: "idColegio", value: id }))
                                dispatch(setData({ name: "colegio", value: texto }))
                            }}
                        />
                        {/* <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText> */}
                    </FormControl>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-gradocolegio">Grado Colegio</InputLabel>
                        <Select
                            native
                            label="gradocolegio"
                            value={participante?.idGradoColegio || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idGradoColegio',
                                id: 'input-gradocolegio',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listGradoColegio?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneSeguro"
                            checked={participante.tieneSeguro}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneSeguro", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Seguro" />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-tiposeguro">Tipo Seguro</InputLabel>
                        <Select
                            native
                            label="tiposeguro"
                            value={participante?.idTipoSeguro || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTipoSeguro',
                                id: 'input-tiposeguro',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipoSeguro?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField
                        name="detalleSeguro"
                        label="Detalle Seguro"
                        fullWidth
                        value={participante.detalleSeguro}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneHermanos"
                            checked={participante.tieneHermanos}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneHermanos", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Hermanos" />
                </Box>
                <Box sx={{ gridColumn: { sm: "2 / 4" }, minWidth: 0 }}>
                    <TextField
                        name="detalleHermanos"
                        label="Detalle Hermanos"
                        fullWidth
                        value={participante.detalleHermanos}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="detalleConvivencia"
                        label="Detalle Convivencia"
                        fullWidth
                        value={participante.detalleConvivencia}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel control={
                        <Checkbox
                            name="tieneDiagnostico"
                            checked={participante.tieneDiagnostico}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "tieneDiagnostico", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Tiene Diagnostico" />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField
                        required
                        name="fechaUltimoDiagnostico"
                        label="Fecha Ult. Diagnostico"
                        fullWidth
                        type="date"
                        //defaultValue={moment()}
                        value={participante.fechaUltimoDiagnostico ? moment(participante.fechaUltimoDiagnostico).format('yyyy-MM-DD') : ''}
                        onChange={setDataEntity}
                        // error={validate.fechaUltimoDiagnostico && validation.fechaUltimoDiagnostico.error}
                        // helperText={validate.fechaUltimoDiagnostico && validation.fechaUltimoDiagnostico.error ? validation.fechaUltimoDiagnostico.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
                </Box>
                </Grid>
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel control={
                        <Checkbox
                            name="asisteATerapia"
                            checked={participante.asisteATerapia}
                            disabled={isReadOnly}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "asisteATerapia", value: event.target.checked}))
                            }}
                            size='small'
                        />
                        } label="Asiste a Terapia" />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    {/* <FormControl required fullWidth error={validate?.idSexo && validation.idSexo.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                        <Select
                            native
                            label="tipoterapia"
                            value={participante?.idTipoTerapia || 0}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTipoTerapia',
                                id: 'input-tipoterapia',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTipoTerapia?.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate?.idSexo && validation.idSexo.error ? validation.idSexo.message : ""}</HelperText> */}
                    </FormControl>
                </Box>
                </Box>
                </Grid>
                {/* <Grid item xs={6} sm={2}>
                    <TextField
                        disabled
                        name="ubigeoCasoAccidente"
                        label="Ubigeo"
                        value={participante.ubigeoCasoAccidente}
                        fullWidth
                        // onChange={(event) => {
                        //     dispatch(setData({name: "ubigeoCasoAccidente", value: event.target.value}));
                        // }}
                        size="small"
                    />
                </Grid> */}
                <Grid item xs={12}>
                <Box sx={fila}>
                <Box sx={{ gridColumn: { sm: "1 / 3" }, minWidth: 0 }}>
                    <TextField
                        required
                        name="lugarCasoAccidente"
                        label="Lugar Caso Accidente"
                        fullWidth
                        value={participante.lugarCasoAccidente}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField
                        required
                        name="direccionCasoAccidente"
                        label="Direcccion"
                        value={participante.direccionCasoAccidente}
                        fullWidth
                        size="small"
                        disabled={isReadOnly}
                        InputProps={{
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton aria-label="Buscar Direccion" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                        openCloseDirectionSearch()
                                    }}>
                                        <IconSearch fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
                </Box>
                </Grid>
                {/* <Grid item xs={12} sm={3}>
                    <TextField
                        disabled
                        name="padre"
                        label="Padre"
                        fullWidth
                        value={participante.padre}
                        size="small"
                    />
                </Grid>
                <Grid item xs={2} sm={1}>
                    <IconButton aria-label="Buscar Padre" size='small' onClick={() => {
                        openCloseSearchFather()
                    }}>
                        <IconSearch />
                    </IconButton>
                    <IconButton aria-label="Registrar Padre" size='small' onClick={() => {
                        openCloseFatherRegister()
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        disabled
                        name="madre"
                        label="Madre"
                        fullWidth
                        value={participante.madre}
                        size="small"
                    />
                </Grid>
                <Grid item xs={2} sm={1}>
                    <IconButton aria-label="Buscar Madre" size='small' onClick={() => {
                        openCloseSearchMother()
                    }}>
                        <IconSearch />
                    </IconButton>
                    <IconButton aria-label="Registrar Madre" size='small' onClick={() => {
                        openCloseMotherRegister()
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Grid> */}
            </Grid>
            </Grid>
            <DirectionSearch open={openDirectionSearch} openClose={openCloseDirectionSearch} setSelection={setSelectDirectionSearch} />
            <MemberSearch empresa="N" open={openSearchMember} openClose={openCloseSearchMember} setSelection={setMemberFound} />
            <MemberRegister key={participante.idPersona} id={participante.idPersona} sliceKey="memberRegister" idTipoPersona={0} tipoPersona="" hideInputs={true} open={openMemberRegister} openClose={openCloseMemberRegister} setNewPersonSaved={setMemberNew} />
            <FatherSearch empresa="N" open={openSearchFather} openClose={openCloseSearchFather} setSelection={setFatherFound} />
            <FatherRegister idTipoPersona={23} tipoPersona="Padre" open={openFatherRegister} openClose={openCloseFatherRegister} setNewPersonSaved={setFatherNew} />
            <MotherSearch empresa="N" open={openSearchMother} openClose={openCloseSearchMother} setSelection={setMotherFound} />
            <MotherRegister idTipoPersona={93} tipoPersona="Madre" open={openMotherRegister} openClose={openCloseMotherRegister} setNewPersonSaved={setMotherNew} />
        </Grid>
    );
}
export default Member;
